import {Stack, Typography} from '@mui/material'
import {colors} from '@/constants'
import React from 'react'
import Modal from '@/components/NotificationModal'
import TransCustom from '@/components/UI/i18next'

interface CongratulationsProps {
  status: string
  count: number
}

const Index = ({count, status}: CongratulationsProps) => {
  return (
    <Modal
      zIndex={1400}
      firework={true}
      styles={{
        background: '#0F0A00F2',
        padding: '50px 70px',
        minWidth: '800px',
      }}
      stylesContainer={{
        minWidth: '800px',
        border: `1px solid ${colors.lightBrown}`,
        borderRadius: '20px',
        textAlign: 'center',
      }}>
      <TransCustom i18nKey='1230' variant="h1" color={colors.yellow} />
      <Stack
        alignItems="center"
        justifyContent="center"
        gap="60px"
        marginTop="60px">
        <TransCustom i18nKey='1329' params={{param1: status}} variant="body1" />
        <TransCustom i18nKey='1330' params={{param1: count}} variant="body1" />
        <TransCustom i18nKey='1331' variant="body1" style={{wordBreak: 'break-word'}} />
      </Stack>
    </Modal>
  )
}

export default Index
